import { IconProps } from "../icon.types"

type Props = IconProps

export const IconCoating = ({ size = 24, ...props }: Props) => {
  const widthPx =
    typeof size === "number" ? size : Number.parseFloat(String(size))
  const w = Number.isFinite(widthPx) ? widthPx : 24

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={(w * 39) / 42}
      viewBox="0 0 42 39"
      fill="none"
      {...props}
    >
      <path
        d="M20.4702 1C20.4702 1 26.9702 10.3333 26.9702 14.3333C26.9702 18.0667 24.1102 21 20.4702 21C16.8302 21 13.9702 18.0667 13.9702 14.3333C13.9702 10.3333 20.4702 1 20.4702 1Z"
        stroke="black"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M40.5845 23.1859C40.9734 23.3329 41.2309 23.7055 41.231 24.1214C41.2309 24.5372 40.9735 24.9099 40.5845 25.0569L20.9692 32.4622C20.7417 32.5481 20.4897 32.548 20.2622 32.4622L0.646973 25.0569C0.257982 24.91 0.000572354 24.5372 0.000488281 24.1214C0.000510909 23.7055 0.257916 23.3329 0.646973 23.1859L14.7095 17.8763C15.092 18.4878 15.5749 19.0275 16.1362 19.4749L3.83154 24.1214L20.6157 30.4573L37.3999 24.1214L24.4917 19.2474C25.0162 18.7796 25.4618 18.2268 25.8081 17.6077L40.5845 23.1859Z"
        fill="black"
      />
      <path
        d="M40.584 29.6593C40.9731 29.8063 41.2304 30.1789 41.2305 30.5948C41.2304 31.0108 40.9731 31.3834 40.584 31.5304L20.9688 38.9357C20.7412 39.0216 20.4893 39.0216 20.2617 38.9357L0.646484 31.5304C0.257497 31.3834 8.8128e-05 31.0107 0 30.5948C2.26266e-05 30.179 0.257467 29.8063 0.646484 29.6593L6.74121 27.3575L9.57324 28.4259L3.83105 30.5948L20.6152 36.9308L37.3994 30.5948L31.6562 28.4259L34.4883 27.3575L40.584 29.6593Z"
        fill="black"
      />
    </svg>
  )
}
